import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'Apenas confirmás el pago recibís un email con el link de descarga. Todo es 100% digital en formato PDF. Acceso inmediato en menos de 5 minutos, cualquier día, a cualquier hora.'
}, {
  question: '¿Para qué tipo de instructor es el Megapack?',
  answer: 'Para instructores y dueños de dojos de cualquier disciplina marcial: karate, judo, taekwondo, kickboxing, BJJ, kung fu, defensa personal o artes marciales mixtas. El sistema es universal y se adapta a cualquier arte.'
}, {
  question: '¿Necesito experiencia previa en gestión o marketing?',
  answer: 'No. El Megapack está diseñado para instructores que son expertos en su arte pero no en los negocios. Todo está explicado paso a paso con scripts listos para copiar, planillas para completar y protocolos para implementar desde el día uno.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos ofertas?',
  answer: 'Sí. Los 6 bonos de implementación inmediata están incluidos en ambas opciones sin costo extra. Si elegís el Megapack + Academia Online™ además recibís el sistema completo para digitalizar tu dojo y generar ingreso pasivo desde el primer mes.'
}, {
  question: '¿Qué pasa si mis alumnos siguen abandonando después de implementarlo?',
  answer: 'Para eso existe el Tomo 2 de Pedagogía de Retención y el Bono 3 de Scripts Anti-Deserción. Te damos el protocolo exacto de seguimiento, los mensajes listos para enviar y el sistema de detección temprana de alumnos en riesgo de deserción.'
}, {
  question: '¿Sirve si tengo un dojo pequeño con pocos alumnos?',
  answer: 'Especialmente para ese caso. El sistema está diseñado para llevar un dojo de 15 a 50 alumnos con la misma estructura que usan las academias más grandes. Cuanto antes lo implementés, más rápido crecés.'
}, {
  question: '¿Es editable? ¿Puedo modificarlo?',
  answer: 'El material viene en PDF listo para implementar. Los scripts y planillas están diseñados para usar tal como están, personalizando solo con el nombre de tu dojo. No necesitás modificar nada para que funcione.'
}, {
  question: '¿Qué diferencia tiene con cursos de gestión genéricos?',
  answer: 'Los cursos genéricos no entienden la realidad del instructor argentino ni el modelo de negocio de un dojo. El Megapack fue creado específicamente para artes marciales en Argentina, con precios en pesos, plataformas locales y la cultura del instructor rioplatense.'
}, {
  question: '¿Por qué elegir el Megapack + Academia Online™?',
  answer: 'Porque el Megapack te da el sistema para profesionalizar tu dojo físico y la Academia Online™ te enseña a generar un segundo ingreso digital sin límite geográfico. Son los dos pilares del instructor moderno resueltos juntos en un solo sistema.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días de garantía total sin preguntas. Si abrís los tomos, los revisás y no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin drama.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(26, 26, 26)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-115">
      <div className="mx-auto max-w-3xl" data-id="element-116">
        {/* TÍTULO */}
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-8" data-id="element-117">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-118">
          {faqs.map((faq, i) => <div key={i} className="bg-gray-900 transition-colors border border-red-900 rounded-lg shadow-sm overflow-hidden" data-id="element-119">
              {/* PREGUNTA */}
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-4 py-3 m-0" style={{
            fontFamily: 'inherit'
          }} data-id="element-120">
                <span className="text-sm font-bold text-white" data-id="element-121">
                  ❓ {i + 1} — {faq.question}
                </span>
                <span className={`shrink-0 text-lg text-red-500 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-122">
                  +
                </span>
              </button>

              {/* RESPUESTA */}
              {openIndex === i && <div className="px-4 pb-4 pt-0" data-id="element-123">
                  <div className="h-px w-full bg-red-900/50 mb-3" data-id="element-124" />
                  <p className="text-sm text-gray-400 m-0 leading-relaxed" data-id="element-125">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}